module.exports = __webpack_public_path__ + "static/media/logo.29c50d6d.svg";